import createPersistedState from "vuex-persistedstate"
import SecureLS from "secure-ls"

const ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "PlantIQ"
})

export default createPersistedState({
  //TODO  storage: ls,
  // storage: {
  //   getItem: key => ls.get(key),
  //   setItem: (key, value) => ls.set(key, value),
  //   removeItem: key => ls.remove(key)
  // },
  paths: ["projectPre.currentProject", "projectPre.currentVrfSystem", "projectPre.currentVrfSystemList", "app.language", "auth.userInfo", "system.oduRates", "system.iduRates", "system.zoneList"],
  filter: mutation => !mutation.type.startsWith("auth/")
})



// WEBPACK FOOTER //
// ./src/store/plugins/persistence.js